<div class="layout">
  <app-sidebar
    class="sidebar"
    [class.menu-show]="isShowMenu"
    [class.mob]="isMob"
    (toggleEmitter)="toggle($event)"
  ></app-sidebar>
  <div class="mask" *ngIf="isMob && isShowMenu"></div>
  <div class="inner" [class.menu-show]="isShowMenu" [class.mob]="isMob">
    <app-header class="header"></app-header>
    <app-banner class="banner"></app-banner>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </div>
</div>
